<script lang="ts">
  interface Props {
    href: string;
    title: string;
    active: boolean;
  }

  let { href, title, active }: Props = $props();
</script>

<li class="nav-item">
  <a class="nav-link" class:active {href}>{title}</a>
</li>

<style>
    .nav-link {
        --bs-navbar-active-color: rgba(var(--uams-primary-red-hover-rgb));
        line-height: 1;
        --bs-nav-link-font-weight: 500;
    }

    a {
        text-decoration: none;
    }

    a:focus,
    a:hover {
        text-decoration: underline;
    }
</style>
